import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { sync } from "vuex-router-sync";
import store from "./store/store";

Vue.config.productionTip = false;
sync(store, router);

// const isProd = process.env.NODE_ENV === 'production';

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
